import React from "react";
import { TEMPLATES, DEFAULT_DESIGN_SYSTEM } from "./designSystemDefaults";

function TemplateCard({ template, onSelect }) {
    const c = template.colors;
    return (
        <button
            type="button"
            onClick={() => onSelect(template)}
            className="p-3 border border-input rounded-lg hover:border-primary transition-colors text-left"
        >
            <div className="flex gap-1 mb-2">
                {[c.primary, c.secondary, c.accent, c.background, c.foreground].map((hex, i) => (
                    <div key={i} className="w-6 h-6 rounded-full border border-input" style={{ backgroundColor: hex }} />
                ))}
            </div>
            <div className="text-sm font-medium">{template.name}</div>
            <div className="text-xs text-muted-foreground">{template.description}</div>
        </button>
    );
}

export default function DesignSystemTemplates({ onSelect, onReset }) {
    return (
        <div>
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-sm font-semibold">Templates</h3>
                <button type="button" onClick={onReset} className="px-3 py-1.5 text-xs text-destructive border border-input rounded-md hover:bg-destructive/10">
                    Reset to Defaults
                </button>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                {TEMPLATES.map((t) => (
                    <TemplateCard key={t.name} template={t} onSelect={onSelect} />
                ))}
            </div>
        </div>
    );
}
